import styles from '@/styles/components/common/CardBlock.module.scss'

interface Props {
  styleSecondary?: boolean,
  styleSilver?: boolean,
  withShadow?: boolean,
  className?: string,
  noPad?: boolean,
  disable?: boolean,
  style?: React.CSSProperties
}

export const CardBlock: React.FC<Props> = ({ children, styleSecondary = false, disable = false, styleSilver = false, withShadow = false, noPad = false, className = '', style }) => {
  return (
    <div style={style} className={`
      ${className}
      ${styles.card_block}
      ${styleSecondary ? styles.card_block_secondary : ''}
      ${styleSilver ? styles.card_block_silver : ''}
      ${withShadow ? styles.card_block_with_shadow : ''}
      ${noPad ? styles.card_block_no_pad : ''}
      ${disable ? styles.card_block_disable : ''}
    `}>
      {children}
    </div>
  )
}
